import { render, staticRenderFns } from "./ExtendRental.vue?vue&type=template&id=6d10038e&scoped=true"
import script from "./ExtendRental.vue?vue&type=script&lang=js"
export * from "./ExtendRental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10038e",
  null
  
)

export default component.exports